import React from "react";
import { Box, Typography, Autocomplete, TextField } from "@mui/material";
import { useFetchDocument } from "../../../hooks/useGetDocument";

const DocumentAutocompleteClone = ({ token, documentID, setDocumentID, setNameDocument, excludeId }) => {
  const { document, loading } = useFetchDocument(token);

  const documentOptions = document.map((doc) => ({
    id: `${doc.ID_DOCUMENTO}`,
    label: doc.NOMBRE_DOCUMENTO,
    disabled: excludeId ? `${doc.ID_DOCUMENTO}` === `${excludeId}` : false,
  }));

  const selectedDocument = documentOptions.find((doc) => doc.id === documentID) || null;

  const handleSelectionChange = (event, value) => {
    if (value && !value.disabled) {
      setDocumentID(value.id);
      setNameDocument(value.label);
    } else {
      setDocumentID(null);
      setNameDocument("");
    }
  };

  return (
    <Autocomplete
      disablePortal
      freeSolo
      size="small"
      options={documentOptions}
      getOptionLabel={(option) => option.label || ""}
      getOptionDisabled={(option) => option.disabled}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      loading={loading}
      value={selectedDocument}
      onChange={handleSelectionChange}
      renderOption={(props, option) => (
        <li {...props} key={option.id}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
            <span>{option.label}</span>
            {option.disabled && (
              <Typography variant="caption" sx={{ ml: 1, fontStyle: "italic", color: "text.disabled" }}>
                Documento activo
              </Typography>
            )}
          </Box>
        </li>
      )}
      renderInput={(params) => <TextField {...params} label="Buscar documento" />}
    />
  );
};

export default DocumentAutocompleteClone;